import newsmain       from '@/pages/news/news-main/NewsMain.vue'
import news       from '@/pages/news/news-page/News.vue'
import newsdetail       from '@/pages/news/news-detail'
import events       from '@/pages/news/events/Events.vue'
import eventsdetail       from '@/pages/news/event-detail'

export default [
    {
        path: '/newsmain',
        name: 'newsmain',
        component: newsmain,
    },
    {
        path: '/news',
        name: 'news',
        component: news,
    },
    {
        path: '/newsdetail',
        name: 'newsdetail',
        component: newsdetail,
    },
    {
        path: '/events',
        name: 'events',
        component: events,
    },
    {
        path: '/eventsdetail',
        name: 'eventsdetail',
        component: eventsdetail,
    },
]
